export default {
    init() {
        // JavaScript to be fired on the home page
		$('#side_buttons').removeClass('d-md-block');
        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            var height = $('.banner').height() + $('.services_slider_main').height() - 100;
            if (scroll >= height) {
                $('#side_buttons').addClass('d-md-block');
            } else {
                $('#side_buttons').removeClass('d-md-block');
            }
        });
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js